import Filter from './Filter.js';
import { sliderText } from './helpers';
import noUiSlider from 'nouislider';
import _ from 'underscore';
import { inventoryLocalization } from '../translations';

/**
 * Handles Slider Creation
 */
class Slider extends Filter {
  constructor(searchParameter, options, updateCallback, searchParameters) {
    super({ searchParameter, options, updateCallback, searchParameters });
    this.container = document.getElementById(searchParameter);
  }

  create() {
    this.container.classList.add('text-center');

    if (this.searchParameters[`${this.searchParameter}_min`]) {
      this.options.start[0] = this.searchParameters[`${this.searchParameter}_min`];
    }

    if (this.searchParameters[`${this.searchParameter}_max`]) {
      this.options.start[1] = this.searchParameters[`${this.searchParameter}_max`];
    }

    //create slider tooltip
    const tooltip = document.createElement('div');
    tooltip.classList.add(`sliderTooltip`);
    tooltip.classList.add(`${this.searchParameter}FilterTooltip`);

    //create noUiSlider
    const slider = document.createElement('div');
    slider.classList.add(`${this.searchParameter}FilterSlider`);

    this.container.appendChild(tooltip);
    this.container.appendChild(slider);
    noUiSlider.create(slider, this.options);
  }

  update() {
    let slider = this.container.querySelector(`.${this.searchParameter}FilterSlider`);
    let tooltip = this.container.querySelector(`.${this.searchParameter}FilterTooltip`);
    let searchParameter = this.searchParameter;
    let searchParameters = this.searchParameters;
    let options = this.options;

    slider.noUiSlider.on('update', function (values) {
      let min = slider.noUiSlider.options.range.min;
      let max = slider.noUiSlider.options.range.max;

      if (parseInt(values[0]) === min[0] && parseInt(values[1]) === max[0]) {
        tooltip.innerText = inventoryLocalization.gettext('Select Price Range');
        return;
      }

      tooltip.innerText = sliderText(searchParameter, options, values[0], values[1]);
    });

    slider.noUiSlider.on(
      'end',
      _.debounce(function (values) {
        searchParameters[`${searchParameter}_min`] = parseInt(values[0]);
        if (parseInt(values[0]) === 0) {
          searchParameters[`${searchParameter}_min`] = null;
        }

        searchParameters[`${searchParameter}_max`] = parseInt(values[1]);
        if (parseInt(values[1]) === options.range.max[0]) {
          searchParameters[`${searchParameter}_max`] = null;
        }

        this.container.dispatchEvent(new Event('dspFilter.change'));

        if (this.updateCallback && typeof this.updateCallback === 'function') {
          this.updateCallback(searchParameter);
        }
      }, 500).bind(this)
    );
  }
}

export default Slider;
